import { AfterViewInit, Component, ElementRef, SimpleChanges, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { NgbOffcanvasConfig, NgbOffcanvas, NgbModal, NgbModalConfig, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { IgxStepComponent, IgxStepperModule, IStepChangingEventArgs } from 'igniteui-angular';
import { IgxStepper } from 'igniteui-angular/lib/stepper/stepper.common';
import { ToastrService } from 'ngx-toastr';
import { filter } from 'rxjs';
import { FamilyForm, InscriptionForm, OldSchool, OldSchoolForm } from '../../../../../core/request-forms/InscriptionForm';
import { AcademicYearService } from '../../../../../core/services/academic-year.service';
import { ClassroomService } from '../../../../../core/services/classroom.service';
import { InscriptionFileService } from '../../../../../core/services/inscription-file.service';
import { InscriptionService } from '../../../../../core/services/inscription.service';
import { AppClassroom } from '../../../../../core/utils/app-classrooms';
import { CountryList } from '../../../../../core/utils/app-countries';
import { AppNationalities } from '../../../../../core/utils/app-nationality';
import { AppSweetAlert } from '../../../../../core/utils/app-sweet-alert';
import { FileService } from '../../../../../core/utils/file-service';
import { LocalStorageService } from '../../../../../core/utils/local-stoarge-service';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { HeaderComponent } from '../../../layout/includes/header/header.component';

@Component({
    selector: 'app-inscription-create',
    templateUrl: './inscription-create.component.html',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule, IgxStepperModule, IgxStepComponent],
    styleUrls: ['./inscription-create.component.css']
})
export class InscriptionCreateComponent implements AfterViewInit {
  myRequestForm=InscriptionForm
  oldShcoolForm=OldSchoolForm
  familyForm=FamilyForm
  classrooms:any[]=[];
  requiredFiles:any[]=[];
  settedFiles:any[]=[];
  countries=CountryList;
  classroomsList=AppClassroom;
  nationalList=AppNationalities;
  imageSrc!: string | SafeResourceUrl | undefined ;
  fileInput:any
  last_step=-1;
  loading=false
  ay:any;
  oldSchoolCurrentIndex:any=0;
  familyCurrentIndex:any=0;
  system=""
  tag="admin-inscription-new"

@ViewChild("reqTop") reqTop!: ElementRef<HTMLElement>;
@ViewChild('stepper')stepper!:IgxStepper
@ViewChild('fileInp')fileInp!:ElementRef


  constructor(
    private ayService:AcademicYearService,
    private classroomService:ClassroomService,
    private inscriptionFileService:InscriptionFileService,
    private insService:InscriptionService,
    private router:Router,
    private activatedRoute:ActivatedRoute,
    private _sanitizationService: DomSanitizer,
    configOffCanvas: NgbOffcanvasConfig,
     private offcanvasService: NgbOffcanvas,
     private toastrService: ToastrService,
     private insFileService:InscriptionFileService,
     private lsService:LocalStorageService,
     config: NgbModalConfig,
    private modalService: NgbModal) {
      config.backdrop = 'static';
      config.keyboard = false;
      
    configOffCanvas.position = 'end';
		configOffCanvas.backdropClass = 'bg-dark';
		configOffCanvas.keyboard = false;
		router.events
    .pipe(
      filter(
        ( event: any ) => {
            alert()
          return( event instanceof NavigationStart );

        }
      )
    )
   }
  ngOnChanges(changes: SimpleChanges): void {
  }
  ngOnDestroy(): void {
    // if (this.myRequestForm.nature_promotor_id != undefined && !this.is_stored) {
    //       AppSweetAlert.confirmBox('warning','Enregistrement de CAPE','Vous étiez en train d\'enregistrer des données, voulez vous concerver les données saisies?').then((result:any)=>{
    //   if(result.value){
    //     this.lsService.set(GlobalName.reqName,JSON.stringify(this.myRequestForm))
    //   }else{
    //     this.lsService.remove(GlobalName.reqName)

    //   }
    // })
    // }

    
  }

  ngOnInit(): void {
  
   // this.getAy()
    this.getClassrooms()
  }

  ngAfterViewInit(){
    //this.stepper.navigateTo(3)
  }

  getClassrooms(){
    this.classroomService.getAll().subscribe((res:any)=>{
      this.classrooms=res.data
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des inscriptions",err)
    })
  }

  loadDocuments(event:any){
    this.requiredFiles=[]
    this.inscriptionFileService.get(event.target.value).subscribe((res:any)=>{
      res.data.forEach((element:any) => this.requiredFiles.push({
        name:element.document?.name,
        fileArrayBuffer:"",
        file:"",
        file_id:element.document?.id,
        isRequired:element.is_active,
        description:"",
        isSetted:false,
        hasFilename:false
      }) );

    },
    (err:any)=>{
AppErrorShow.showError("Gestion des inscriptions",err)
    })
  }
  getAy(){
    this.ayService.get(0).subscribe((res:any)=>{
      this.ay=res.data
    })
  }

  store(insForm:NgForm){

    this.myRequestForm.student.parent.father_phone=this.myRequestForm?.student?.parent?.father_phone?this.myRequestForm?.student?.parent?.father_phone?.internationalNumber:null
    this.myRequestForm.student.parent.mother_phone=this.myRequestForm?.student?.parent?.mother_phone?this.myRequestForm?.student?.parent?.mother_phone?.internationalNumber:null
    this.myRequestForm.student.parent.tutor_phone=this.myRequestForm?.student?.parent?.tutor_phone?this.myRequestForm?.student?.parent?.tutor_phone?.internationalNumber:null

    this.settedFiles=this.requiredFiles.filter((res:any)=> res.isSetted==true);
    this.myRequestForm.documents=this.settedFiles
    this.myRequestForm.has_paid=true;
      let formData= new FormData()
      formData.append("datas",JSON.stringify(this.myRequestForm))
      this.loading=true
    this.insService.store(formData).subscribe((res:any)=>{
      this.reinit()
      insForm.resetForm()
      this.router.navigate(['/admin/inscription-details/'+res.data])
      this.loading=false
        },
    (err:any)=>{
      this.loading=false
      AppErrorShow.showError("Gestion des inscriptions",err)

    })
   
  }


  trackByFn(index:any, item:any) {
    return item.isSetted; 
  }
  



  
  open(content:any, index:any) {
    this.readURL(this.requiredFiles[index].file)
		this.offcanvasService.open(content);
	}
  readURL(file: File): void {
    // this.imageSrc=this._sanitizationService.bypassSecurityTrustResourceUrl(file)
    const reader = new FileReader();
    reader.onload = e =>{
     let src = reader.result as string
      this.imageSrc=this._sanitizationService.bypassSecurityTrustResourceUrl(src)

    };
    reader.readAsDataURL(file);

}

removeFile(i:any){
  //this.fileInputs.splice(i,1)
  AppSweetAlert.confirmBox("error","Document joint","Voulez vous retier cette pièce ?").then((result:any)=>{
    if (result.isConfirmed) {
      this.requiredFiles[i].file="",
      this.requiredFiles[i].isSetted=false
    }
  })
 
}

  async upload(event:any, index:any){
  if(event.target.files.length>0){
   this.fileInput=event.target.files[0]
    let current =this.requiredFiles[index];
       current.fileArrayBuffer=await FileService.fromArrayBufferToBase64(await FileService.readFileAsync(this.fileInput)) 
       current.file=this.fileInput
       current.isSetted=true
       current.hasFilename=false
      this.requiredFiles.slice(index,current)
  }
} 

  next(){
    // Cette methode reinscrivait un abonnement a activeStepChanging a chaque
    // appel : les validateurs se cumulaient et les avertissements se
    // dupliquaient. Le gabarit relie deja handleActiveStepChanging, qui
    // couvre toutes les etapes, case 4 comprise.
    this.stepper.next()
    this.reqTop.nativeElement.scrollIntoView()
  }

  prev(){

    this.stepper.prev()
  }

  verifyStepper1(res:any){
    if(
      this.myRequestForm.student.lastname == "" ||
      this.myRequestForm.student.firstname == "" ||
      this.myRequestForm.student.birthdate == "" ||
      this.myRequestForm.student.birthplace == "" ||
      this.myRequestForm.student.origin == "" ||
      this.myRequestForm.student.sex == "" ||
      this.myRequestForm.student.languages == "" ||
      this.myRequestForm.student.address == "" 
      ){
        res.cancel=true
        this.toastrService.warning('Veuillez remplir tous les champs requis','Renseignement concernant l\'enfant')
    }else{
      res.cancel=false
    }
}
  verifyStepper2(res:any){
    // if(
    //   this.myRequestForm.old_schools.length == 0
    //   ){
    //     res.cancel=true
    //     this.toastrService.warning('Veuillez remplir tous les champs requis','Renseignement concernant l\'enfant')
    // }else{
    //   res.cancel=false
    // }
    res.cancel=false
  }
  verifyStepper3(res:any){
    // Cette etape recense les freres et soeurs, facultatifs : elle
    // revalidait par copier-coller les champs de l'etape 1.
    res.cancel=false
  }

  verifyStepper4(res:any){
      if(
      this.myRequestForm.student.parent.father_lastname == "" ||
      this.myRequestForm.student.parent.father_firstname == "" ||
      this.myRequestForm.student.parent.father_email == "" ||
      this.myRequestForm.student.parent.father_address == "" ||
      this.myRequestForm.student.parent.father_phone.internationalNumber == "" ||
      this.myRequestForm.student.parent.father_job == "" ||
      this.myRequestForm.student.parent.mother_lastname == "" ||
      this.myRequestForm.student.parent.mother_firstname == "" ||
      this.myRequestForm.student.parent.mother_email == "" ||
      this.myRequestForm.student.parent.mother_address == "" ||
      this.myRequestForm.student.parent.mother_phone.internationalNumber == "" ||
      this.myRequestForm.student.parent.mother_job == "" 
      ){

        res.cancel=true
        this.toastrService.warning('Veuillez remplir tous les champs requis','Renseignement concernant les parents')
    }else{
      if (!this.isValidEmail(this.myRequestForm.student.parent.father_email) || !this.isValidEmail(this.myRequestForm.student.parent.mother_email)) {
        res.cancel=true
        this.toastrService.warning('Veuillez insérer un email valide','Email validation')
  
      }else{
        res.cancel=false
  
      }
    }
  

  }
  verifyStepper5(res:any){
    // Le responsable de secours est facultatif : aucune contrainte ici.
    res.cancel=false
  }

  public handleActiveStepChanging(event: IStepChangingEventArgs) {
    if (event.newIndex >  event.oldIndex) {

    switch (event.oldIndex) {

      case 0:
          this.verifyStepper1(event)
        break;
      case 1:
          this.verifyStepper2(event)
        break;
      case 2:
          this.verifyStepper3(event)
        break;
      case 3:
          this.verifyStepper4(event)
        break;
      case 4:
          this.verifyStepper5(event)
        break;
    
      default:
        this.stepper.navigateTo(0)
        break;
    }
  }
   }

 


  filterByType(type:any){
    return this.requiredFiles.filter((el:any) => el.type==type && el.isRequired == true)
  }

  verifiedFiles(type:any){
    let files= this.filterByType(type)
    let notSetted= files.filter((el:any)=>el.isSetted==false);

    return notSetted.length >0 ? false:true
  }

  checkControl(){
    //this.dropdownList=this.dropdownList2
  }


  public isValidEmail(emailString: string): boolean {
    try {
      let pattern = new RegExp("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$");
      let valid = pattern.test(emailString);
      return valid;
    } catch (TypeError) {
      return false;
    }
  }

  openOldSchoolEdition(content:any,i:any){
    this.oldSchoolCurrentIndex=i
    this.modalService.open(content)
  }
  removeItem(i:any){
    this.myRequestForm.old_schools.splice(i,1)
  }

  addSchool(form:NgForm){
    this.myRequestForm.old_schools.push(form.value)
    this.modalService.dismissAll()
    form.resetForm()

  }
  editSchool(){
    this.modalService.dismissAll()
  }
 

  openFamilyEdition(content:any,i:any){
    this.familyCurrentIndex=i
    this.modalService.open(content)
  }
  removeItem2(i:any){
    this.myRequestForm.student.parent.families.splice(i,1)
  }

  addFamily(form:NgForm){
    this.myRequestForm.student.parent.families.push(form.value)
    this.modalService.dismissAll()
    form.resetForm()
  }
  editFamily(){
    this.modalService.dismissAll()
  }

  add(content:any){
    this.modalService.open(content,{size:'lg'});
  }

  convertTobase64(){
    this.settedFiles.forEach(async (el:any) => {
      el.fileArrayBuffer=await FileService.fromArrayBufferToBase64(await FileService.readFileAsync(el.file)) 
    })
  }
  

  reinit(){
    this.myRequestForm={
      student:{
      firstname:"",
      lastname:"",
      birthdate:"",
      birthplace:"",
      address:"",
      photo:"",
      observation:"",
      sex:"",
      languages:"",
      origin:"",
      parent:{
          father_lastname:"",
          father_firstname:"",
          father_email:"",
          father_address:"",
          father_job:"",
          father_phone:"",
          mother_lastname:"",
          mother_firstname:"",
          mother_email:"",
          mother_address:"",
          mother_job:"",
          mother_phone:"",
          tutor_lastname:"",
          tutor_firstname:"",
          tutor_email:"",
          tutor_address:"",
          tutor_job:"",
          tutor_phone:"",
          families:[]
      },
      classroom:""
      },
      old_schools:[],
      documents:[]
      }
  }
}

